import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './App.css';
import './react-bootstrap-table.css';
import { Switch, Link, Route } from 'react-router-dom';
import database from './BD/database';
import firebase from 'firebase';
import Login from './Login/Login';
import Slide from './Globals/Slide/slide';
import Alert from 'react-s-alert';
import AlertaContenido from './Alertas/AlertaContenido';
import logo2 from './Globals/Slide/logo.png';
import { withRouter } from "react-router-dom";
import { Pulse } from 'react-preloading-component';

/*Importando el store de redux*/
import store from '../store';
import history from '../history';
/*Archivos para en enrutamiento*/

import cargaEmple from './Programacion/cargaEmple';
import ViajeNuevoA from './Programacion/nuevoViajeA';
import ViajeNuevo from './Programacion/nuevoViaje';
import NuevoTipo from './Programacion/selecionTipo';
import SelecionRango from './Programacion/selecionRango';
import Empleados from './Empleados/Empleados';
import Vehiculos from './Vehiculos/Vehiculos';
import TiposVehiculos from './Vehiculos/TiposVehiculos';
import TarifasVehiculos from './Tarifas/TarifasVehiculos';
import Socios from './Socios/Socios';
import Invitados from './Invitados/Invitados';
import InvitadosEmpresas from './Invitados/InvitadosEmpresas';
import Empresa from './Empresa/Empresa';
import Calificaciones from './Calificaciones1/Calificaciones';
import TiposCalificaciones from './Calificaciones1/TiposCalificaciones';
import ViajesEmpleados from './Empleados_empresa/ViajesEmpleados';
import Viajes from './Empleados_empresa/Viajes';
import VehiculosBases from './Vehiculos_Bases/VehiculosBases';
import EmpleadoEmpresa from './Empleados_empresa/Empleados_empresa';
import Perfiles from './Perfiles/Perfiles';
import Informacion from './Informacion/Informacion';
import Usuarios from './Usuarios/Usuarios';
import Tarifas from './Tarifas/Tarifas';
import Home from './Home';
import Bases from './Bases/Bases';
import Costos from './Costos/Costos';
import Asignar from './Asignar/Asignar';
import Reportes from './Reportes/Reportes';
import ReporteTemplate from './Reportes/ReporteTemplate';
import ReporteGeneralViajesEmpresa from './Reportes/ReporteGeneralViajesEmpresa';
import ReporteCalificaciones from './Reportes/ReporteCalificaciones';
import MapaGlobal from './VistaGlobal/MapaGlobal';
import cambioViajes from './Programacion/cambioViajes';
import planiViajes from './Planificacion/planiViajes';
import planiViajesA from './PlanificacionE/planiViajes';
import ReservaEmpre from './Reservas/reservasEmpre';
import ReservaEmpreA from './Reservas/reservasEmpreA';
import AsignarConductor from './Reservas/asignarConductor';
import ReporteNew from './Reportes/ReporteNew';
import ReporteAsignacionViajes from './Reportes/ReporteAsignacionViajes';
import Empleados_Home from './Emp_Empresas/Empleados_Home';

/*Reportes establecidos para los socios*/
import ReporteConductores from './Perfil_Socios/ReporteConductores';
import ReporteVehiculos from './Perfil_Socios/ReporteVehiculos';
import ReporteViajesConductores from './Perfil_Socios/ReporteViajesConductores';

/*Reportes establecidos para los socios*/

//Reporte de viajes de empleados por empresas
import DetalleViajesEmpresas from './ViajesEmpresas/DetalleViajesEmpresas';

/*Fin archivos para el enrutamiento*/

// mandatory
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/genie.css';

//Components
import Content from './Globals/Content/Content';
import Emp_Empleados from './Emp_Empresas/Emp_Empleados';

import Menu from './Menu/Menu';
import logo from './logo.png';
import TarifasAvianca from './Tarifas/TarifasAvianca';
import BitacoraEmpleados from './Empleados/BitacoraEmpleados';

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			rutas: [],
			paginas: [],
			usuario: null,
			tipo: '',
			authUser: null,
			perfil_usuario: null,
			accesoKey: '',
			nodoEmpresa: '',
			nombreEmpresa: '',
			nodo_empresa: '',
			nombre_empresa: '',
			estado_usuario: true,
			existsEmpleado: false,
			existsUsuarioApp: false,
			existsUsuarioAcacya: false,
			existsSocios: false,
			isAuthLoading: true,
			loadedComponents: 0,
			isHeaderLoaded: false,

		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.logout = this.logout.bind(this);
		this.empresaRef = database.ref().child('Empresa');
		this.renderContent = this.renderContent.bind(this);
		this.renderRoutes = this.renderRoutes.bind(this);
		this.pushRutas = this.pushRutas.bind(this);
		this.guardarRutas = this.guardarRutas.bind(this);
		this.comprobarTipoUsuario = this.comprobarTipoUsuario.bind(this);
		this.updateStateEmpresa = this.updateStateEmpresa.bind(this);
		this.handleComponentLoad = this.handleComponentLoad.bind(this);
	}

	static propTypes = {
		children: PropTypes.object.isRequired
	};

	componentDidMount() {
		this.setState({ isAuthLoading: true }); // Indicar que la autenticación está en proceso
		firebase.auth().onAuthStateChanged(authUser => {
			this.guardarRutas();
			if (authUser) {
				this.comprobarTipoUsuario();
				this.setState({ authUser, isAuthLoading: false });
			} else {
				this.setState({ authUser: null, isAuthLoading: false });
			}
		});
	}

	makeRoutes(x) {
		return x.route;
	}

	logout(event) {
		this.state.tipo = null;
		this.setState(() => ({
			usuario: null,
			tipo: null,
			authUser: null,
			perfil_usuario: null,
			existsEmpleado: false,
			existsUsuarioAcacya: false,
			existsUsuarioApp: false,
			existsSocios: false,
			rutas: []
		}));

		firebase.auth().signOut().then(function () {

			history.push("/");

		}).catch(function (error) {

		});
	}

	informacionPerfil(uid) {
		database.ref().child('Usuarios_Acacya').orderByKey().equalTo(uid).on('value', this.gotDataUsuarioAcacya, this.errDataUsuarioAcacya);
	}

	gotDataUsuarioAcacya=(data)=>{
		
		let perfil_usuario;
		
		let usuariodata=data.val();
		
		if(usuariodata!=null){
			
			let keys=Object.keys(usuariodata);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
			
				perfil_usuario=usuariodata[k].perfil;
				
			}
			this.setState({perfil_usuario:perfil_usuario});
			
			database.ref().child('Perfiles').orderByChild('nombre').equalTo(this.state.perfil_usuario).once("value", (snapshot)=> {			  
				let accesoKey;
				
				let perfildata=snapshot.val();

				if(perfildata!=null){
					
					let keys=Object.keys(perfildata);
					
					for(let i=0;i<keys.length;i++){
						
						let k=keys[i];
						
						accesoKey=k;
				
					}
					this.setState({accesoKey:accesoKey});
				}
				
				database.ref().child('Accesos').child(this.state.accesoKey).on("value",snapshotAccesos=>{
					
					let paginas=[];					
					let dataaccesos=snapshotAccesos.val();					

					if(dataaccesos!=null){
						
						let keys=Object.keys(dataaccesos);
						
						for(let i=0;i<keys.length;i++){
							
							let k=keys[i];
							
							paginas.push({
								key:k,
								url:dataaccesos[k].url,
								nombre:dataaccesos[k].nombre								
							})
								
						}
						this.setState({paginas:paginas});						
					}
										
				});
						  
			});
			
			
			
		}
	}


    

	errDataUsuarioAcacya = (err) => {
		console.log(err);
	}

	guardarRutas() {
		this.state.rutas = [];
		let url;
		let route;
		let nombre;

		url = "/selecionTipo/:tipo";
		nombre = "seleccion";
		route = <Route path="/selecionTipo/:tipo" component={NuevoTipo} />
		this.pushRutas(url, route, nombre);

		url = "/tarifasAvianca";
		nombre = "Tarifas Avianca";
		route = <Route path="/tarifasAvianca" component={TarifasAvianca} />
		this.pushRutas(url, route, nombre);

		url = "/nuevoViajeA";
		nombre = "Nuevo";
		route = <Route path="/nuevoViajeA" component={ViajeNuevoA} />
		this.pushRutas(url, route, nombre);

		url = "/planiViajesA";
		nombre = "planificacion";
		route = <Route path="/planiViajesA" component={planiViajes} />
		this.pushRutas(url, route, nombre);

		url = "/nuevoViaje";
		nombre = "Nuevo";
		route = <Route path="/nuevoViaje" component={ViajeNuevo} />
		this.pushRutas(url, route, nombre);

		url = "/global";
		nombre = "Vista Global";
		route = <Route path="/global" component={MapaGlobal} />
		this.pushRutas(url, route, nombre);

		url = "/selecionRango";
		nombre = "Rango";
		route = <Route path="/selecionRango" component={SelecionRango} />
		this.pushRutas(url, route, nombre);

		url = "/reservaE";
		nombre = "Reserva";
		route = <Route path="/reservaE" component={ReservaEmpreA} />
		this.pushRutas(url, route, nombre);

		url = "/vehiculos";
		nombre = "Vehiculos";
		route = <Route path="/vehiculos" component={Vehiculos} />;
		this.pushRutas(url, route, nombre);

		url = "/costos";
		nombre = "Costos";
		route = <Route path="/costos" component={AsignarConductor} />;
		this.pushRutas(url, route, nombre);

		url = "/asignar";
		nombre = "Reservas";
		route = <Route path="/asignar" component={Asignar} />;
		this.pushRutas(url, route, nombre);

		url = "/tipos_vehiculos";
		nombre = "Tipos de Vehiculos";
		route = <Route path="/tipos_vehiculos" component={TiposVehiculos} />
		this.pushRutas(url, route, nombre);


		url = "/empleados";
		nombre = "Empleados";
		route = <Route path="/empleados" component={Empleados} />;
		this.pushRutas(url, route, nombre);

		url = "/socios";
		nombre = "Socios";
		route = <Route path="/socios" component={Socios} />
		this.pushRutas(url, route, nombre);

		url = "/empresa";
		nombre = "Empresa";
		route = <Route path="/empresa" component={Empresa} />;
		this.pushRutas(url, route, nombre);

		url = "/informacion";
		nombre = "Información";
		route = <Route path="/informacion" component={Informacion} />;
		this.pushRutas(url, route, nombre);

		url = "/perfiles";
		nombre = "Perfiles";
		route = <Route path="/perfiles" component={Perfiles} />
		this.pushRutas(url, route, nombre);

		url = "/tarifas";
		nombre = "Tarifas";
		route = <Route path="/tarifas" component={Tarifas} />
		this.pushRutas(url, route, nombre);

		url = "/invitados";
		nombre = "Invitados";
		route = <Route path="/invitados" component={Invitados} />
		this.pushRutas(url, route, nombre);

		url = "/tarifas_vehiculos";
		nombre = "Tarifas por servicio";
		route = <Route path="/tarifas_vehiculos" component={TarifasVehiculos} />
		this.pushRutas(url, route, nombre);

		url = "/bases";
		nombre = "Bases";
		route = <Route path="/bases" component={Bases} />
		this.pushRutas(url, route, nombre);

		url = "/usuarios";
		nombre = "Usuarios";
		route = <Route path="/usuarios" component={Usuarios} />
		this.pushRutas(url, route, nombre);

		url = "/calificaciones";
		nombre = "Calficaciones";
		route = <Route path="/calificaciones" component={Calificaciones} />
		this.pushRutas(url, route, nombre);

		url = "/vehiculos_bases/:base/:nombre";
		nombre = "vehiculos bases";
		route = <Route path="/vehiculos_bases/:base/:nombre" component={VehiculosBases} />
		this.pushRutas(url, route, nombre);

		url = "/empresa_empleados/:idempresa/:nombre";
		nombre = "Empleados Empresa";
		route = <Route path="/empresa_empleados/:idempresa/:nombre" component={EmpleadoEmpresa} />
		this.pushRutas(url, route, nombre);

		url = "/tipos_calificaciones";
		nombre = "Tipos Calificaciones";
		route = <Route path="/tipos_calificaciones" component={TiposCalificaciones} />
		this.pushRutas(url, route, nombre);

		url = "/reportes";
		nombre = "Reportes";
		route = <Route path="/reportes" component={Reportes} />
		this.pushRutas(url, route, nombre);

		url = "/template";
		nombre = "Template";
		route = <Route path="/template" component={ReporteTemplate} />
		this.pushRutas(url, route, nombre);

		url = "/";
		nombre = "Home";
		route = <Route path="/" component={Home} />
		this.pushRutas(url, route, nombre);

		url = "/template";
		nombre = "Template";
		route = <Route path="/template" component={ReporteTemplate} />
		this.pushRutas(url, route, nombre);

		url = "/cargaemple";
		nombre = "Carga";
		route = <Route path="/cargaemple" component={cargaEmple} />
		this.pushRutas(url, route, nombre);

		url = "/reporte_operacional";
		nombre = "Reporte Operacional";
		route = <Route path="/reporte_operacional" component={ReporteNew} />
		this.pushRutas(url, route, nombre);

		url = "/reporte_asig_viaje";
		nombre = "Reporte asignación Viaje";
		route = <Route path="/reporte_asig_viaje" component={ReporteAsignacionViajes} />
		this.pushRutas(url, route, nombre);

		url = "/";
		nombre = "Empleados_Home";
		route = <Route path="/" component={Empleados_Home} />
		this.pushRutas(url, route, nombre);

		url = "/bitacoraEmpleado";
		nombre = "Bitacora empleados";
		route = <Route path="/bitacoraEmpleado" component={BitacoraEmpleados} />
		this.pushRutas(url, route, nombre);
	}

	pushRutas = (url, route, nombre) => {
		this.state.rutas.push({
			url: url,
			route: route,
			nombre: nombre
		})
		this.setState({
			rutas: this.state.rutas
		})
	}

	comprobarTipoUsuario() {
		this.setState({
			estado_usuario: true,
			existsEmpleado: false,
			existsUsuarioApp: false,
			existsUsuarioAcacya: false,
			existsSocios: false,
			existsEmpleado: false
		});
		

		const uid = firebase.auth().currentUser.uid;
		console.log('UID => ', uid);
		
		database.ref().child('Empleados').child(uid).once("value").then(snapshot => {
			if (snapshot.exists()) {
				const empleadoData = snapshot.val();
				this.setState({ existsEmpleado: true, estado_usuario: empleadoData });
				if (empleadoData.tipo === 'empleado') {
					this.setState({ existsEmpleado: true });
				}
				//console.log('Empleado Data:', empleadoData);
			}
		});

		database.ref().child('Socios').child(uid).once("value").then(snapshot => {
			if (snapshot.exists()) {
				const socioData = snapshot.val();
				this.setState({ existsSocios: true, estado_usuario: socioData.Estado });
				//console.log('Socio Data:', socioData);
			}
		});

		database.ref().child('Clientes').child(uid).once("value").then(snapshot => {
			if (snapshot.exists()) {
				this.setState({ existsUsuarioApp: true });
				//console.log('Cliente Data:', snapshot.val());
			}
		});

		database.ref().child('Usuarios_Acacya').child(uid).once("value").then(snapshot => {
			if (snapshot.exists()) {
				const usuarioAcacyaData = snapshot.val();
				this.setState({ existsUsuarioAcacya: true, estado_usuario: usuarioAcacyaData.estado });
				//console.log('Usuario Acacya Data:', usuarioAcacyaData);
			}
		});

		// La logica comienza aqui si el usuario logueado es empresa,empleado,perfil de acacya o admin
		database.ref().child('Empresa').child(uid).once("value").then(snapshot => {
			if (snapshot.exists()) {
				const empresaData = snapshot.val();
				// Actualiza el store de redux
				if (empresaData.estado === 'Activo') {
					this.updateStateEmpresa(uid, empresaData.codigo_empresa);
					this.setState({
						usuario: firebase.auth().currentUser.email,
						tipo: 'empresa',
						nodoEmpresa: uid,
						nombreEmpresa: empresaData.codigo_empresa
					});
					//console.log('Empresa Data:', empresaData, 'State:', this.state.usuario, this.tipo);
				} else {
					alert('Este usuario esta actualmente inactivo, comunicate con el administrador para más información');
					firebase.auth().signOut().then(() => {
						this.setState({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existsSocios: false,
							existsEmpleado: false,
							rutas: []
						});
					}).catch(error => {
						console.error(error);
					});
				}
			} else if (this.state.existsUsuarioAcacya) {
				if (this.state.estado_usuario === 'Activo') {
					this.informacionPerfil(uid);
					this.setState({
						usuario: firebase.auth().currentUser.email,
						tipo: 'perfil'
					});
					//console.log('Usuario Acacya Activo:', this.state.estado_usuario, 'State:', this.state.usuario, this.tipo);
				} else {
					alert('Este usuario esta actualmente inactivo, comunicate con el administrador para más información');
					firebase.auth().signOut().then(() => {
						this.setState({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existsSocios: false,
							existsEmpleado: false,
							rutas: []
						});
					}).catch(error => {
						console.error(error);
					});
				}
			} else if (this.state.existsSocios) {
				if (this.state.estado_usuario === 'Activo') {
					this.setState({
						usuario: firebase.auth().currentUser.email,
						tipo: 'socio'
					});
					//console.log('Socio Activo:', this.state.estado_usuario);
				} else {
					alert('Este usuario esta actualmente inactivo, comunicate con el administrador para más información');
					firebase.auth().signOut().then(() => {
						this.setState({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existsSocios: false,
							existsEmpleado: false,
							rutas: []
						});
					}).catch(error => {
						console.error(error);
					});
				}
			} else if (this.state.existsEmpleado) {
				if (this.state.existsEmpleado) {
					this.setState({
						usuario: firebase.auth().currentUser.email,
						tipo: 'empleado'
					});
					//console.log('Empleado Activo:', this.state.estado_usuario, 'State:', this.state.usuario, this.tipo);
				} else {
					alert('Este usuario esta actualmente inactivo, comunicate con el administrador para más información');
					firebase.auth().signOut().then(() => {
						this.setState({
							usuario: null,
							tipo: null,
							authUser: null,
							perfil_usuario: null,
							existsEmpleado: false,
							existsUsuarioAcacya: false,
							existsUsuarioApp: false,
							existsSocios: false,
							existsEmpleado: false,
							rutas: []
						});
					}).catch(error => {
						console.error(error);
					});
				}
			} else {
				if (!this.state.existsUsuarioApp && !this.state.existsEmpleado && !this.state.existsUsuarioAcacya) {
					this.setState({
						usuario: firebase.auth().currentUser.email,
						tipo: 'admin'
					});
					//console.log('Admin User:', firebase.auth().currentUser.email);
				}
			}
		});
	}

	handleSubmit(event) {
		//Credenciales
		let user = this.email.value;
		let pass = this.pass.value;

		firebase.auth().signInWithEmailAndPassword(user, pass)
			.then(firebaseUser => {
				//    console.log(firebase.auth().currentUser.uid);
				this.comprobarTipoUsuario();

			})
			.catch(function (error) {
				let errorCode = error.code;
				let errorMessage = error.message;

				if (errorCode === 'auth/user-not-found') {
					alert('No hay registro de usuario correspondiente a este identificador. El usuario puede haber sido eliminado.');
				}
				else {
					alert('La contraseña no es válida o el usuario no tiene una contraseña');
				}
			});

		event.preventDefault();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.paginas.length === 0 && this.state.paginas.length !== 0) {
			this.setState({ isHeaderLoaded: true });
		}
	}

	handleComponentLoad() {
		this.setState(prevState => ({
			loadedComponents: prevState.loadedComponents + 1
		}));
	}

	renderContent() {
		const { children } = this.props;

		if (this.state.authUser !== null) {
			if (this.state.tipo === 'admin') {
				return (
					<div>
						<Menu usuario={this.state.usuario} rutas='admin' onLoad={this.handleComponentLoad} />
						<Slide onLoad={this.handleComponentLoad} />
						<button type="button" onClick={this.logout} className="btn btn-danger btn-sm salir">Cerrar Sesion</button>
						{this.state.loadedComponents >= 2 && (
							<div className="container contenedor contenido">
								<Content body={children} />
							</div>
						)}
					</div>
				);
			} else if (this.state.tipo === 'perfil') {
				return (
					<div>
						{this.state.isHeaderLoaded ? (
							<React.Fragment>
								<Menu usuario={this.state.usuario} rutas={this.state.paginas} onLoad={this.handleComponentLoad} />
								<Slide onLoad={this.handleComponentLoad} />
								<button type="button" onClick={this.logout} className="btn btn-danger btn-sm salir">Cerrar Sesion</button>
							</React.Fragment>
						) : (
							<div>
								<React.Fragment>
									<Menu usuario={this.state.usuario} rutas={this.state.paginas} onLoad={this.handleComponentLoad} />
									<Slide onLoad={this.handleComponentLoad} />
									<button type="button" onClick={this.logout} className="btn btn-danger btn-sm salir">Cerrar Sesion</button>
								</React.Fragment>
							</div>
						)}
					</div>
				);
			} else if (this.state.tipo === 'empleado') {
				return (
					<div>
						<Slide />
						<Menu usuario={this.state.usuario} rutas='empleado' />
					</div>
				);
			} else if (this.state.tipo === 'empresa') {
				return (
					<div>
						<Slide />
						<Menu usuario={this.state.usuario} rutas='empresa' />
					</div>
				);
			} else if (this.state.tipo === 'socio') {
				return (
					<div>
						<Slide />
						<Menu usuario={this.state.usuario} rutas='socios' />
					</div>
				);
			}
		} else {
			if (this.state.isAuthLoading) {
				return <Pulse />;
			}

			if (this.state.authUser === null) {
				return (
					<div className="login">
						<div className="row row-login align-items-center">
							<div className="col-md-4 col-sm-4 columna">
								<h1 className="letras-login">ADMINISTRACION</h1>
								<h1 className="letras-login">WEB</h1>
								<h3 className="letras-login">Taxis Acacya</h3>
							</div>
							<div className="col-md-3"></div>
							<div className="col-md-4 col-sm-4">
								<div className="box">
									<center><img src={logo2} alt="logo" width="180px" /></center>
									<form onSubmit={this.handleSubmit.bind(this)}>
										<div className="inputBox">
											<input type="email" required ref={input => { this.email = input; }} />
											<label>Usuario</label>
										</div>
										<div className="inputBox">
											<input type="password" className="password" required ref={input => { this.pass = input; }} />
											<label>Contraseña</label>
										</div>
										<input type="submit" value="Ingresar" />
									</form>
								</div>
							</div>
							<div className="col-md-1"></div>
						</div>
					</div>
				);
			}
		}
	}

	renderRoutes() {
		console.log('STATE INICIO=> ', this.state);
		if (this.state.perfil_usuario != null && this.state.paginas.length !== 0) {
			let newAccesos = [];
			for (let i = 0; i < this.state.paginas.length; i++) {
				let obj = this.state.rutas.find(ruta => ruta.url === this.state.paginas[i].url);

				if (obj !== undefined) {
					if (obj.nombre === 'Empresa') {
						let routeEmpresa = <Route key="/empresa_empleados/:idempresa/:nombre" path="/empresa_empleados/:idempresa/:nombre" component={EmpleadoEmpresa} />;
						newAccesos.push({
							url: '/empresa_empleados/:idempresa/:nombre',
							route: routeEmpresa,
							nombre: 'Empleados Empresa'
						});
					} else if (obj.nombre === 'Bases') {
						let routeBases = <Route key="/vehiculos_bases/:base/:nombre" path="/vehiculos_bases/:base/:nombre" component={VehiculosBases} />;
						newAccesos.push({
							url: '/vehiculos_bases/:base/:nombre',
							route: routeBases,
							nombre: 'Vehiculos Bases'
						});
					}

					newAccesos.push({
						url: obj.url,
						route: obj.route,
						nombre: obj.nombre
					});
				}
			}
			this.state.rutas = newAccesos;
		}

		if (this.state.authUser !== null && this.state.tipo === 'admin') {
			return (
				<Switch>
					<Route path="/reporte_viajes_empresa" component={ReporteGeneralViajesEmpresa} />
					<Route path="/reporte_asig_viaje" component={ReporteAsignacionViajes} />
					<Route path="/reporte_operacional" component={ReporteNew} />
					<Route path="/detalle_viajes/:empresa" component={DetalleViajesEmpresas} />
					<Route path="/reporte_calificaciones" component={ReporteCalificaciones} />
					{this.state.rutas.map(this.makeRoutes)}
				</Switch>
			);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'empresa') {
			return (
				<Switch>
					<Route exact path="/" component={Home} />
					<Route path="/nuevoViaje" component={ViajeNuevo} />
					<Route path="/reservaE" component={ReservaEmpre} />
					<Route path="/selecionTipo/:tipo" component={NuevoTipo} />
					<Route path="/selecionRango" component={SelecionRango} />
					<Route path="/costos" component={Costos} />
					<Route path="/adicciones" component={cambioViajes} />
					<Route path="/viajes/:uid" component={ViajesEmpleados} />
					<Route path="/invitados" component={InvitadosEmpresas} />
					<Route path="/empleados" component={Emp_Empleados} />
					<Route path="/viajes_empleados" component={Viajes} />
					<Route path="/reporte_operacional" component={ReporteNew} />
					<Route path="/cargaemple" component={cargaEmple} />
					<Route path="/planiViajes" component={planiViajesA} />
				</Switch>
			);
		}
		else if(this.state.authUser!==null && this.state.tipo==='perfil'){
			return(
					<Switch>
						{this.state.rutas.map(this.makeRoutes)}
						<Route path="/" component={Home}/>
					</Switch>			
			);	
		}
		else if (this.state.authUser !== null && this.state.tipo === 'empleado') {
			return (
				<Switch>
					<Route exact path="/" component={Empleados_Home} />
					<Route exact path="/bitacoraEmpleado" component={BitacoraEmpleados} />
				</Switch>
			);
		}
		else if (this.state.authUser !== null && this.state.tipo === 'socio') {
			return (
				<Switch>
					<Route path="/reporte_viajes_conductores" component={ReporteViajesConductores} />
					<Route path="/reporte_conductores" component={ReporteConductores} />
					<Route path="/reporte_vehiculos" component={ReporteVehiculos} />
				</Switch>
			);
		}
		
		else {
			
			return null;
		}
		
		
	}

	updateStateEmpresa(nodo_empresa, nombre_empresa) {
		store.dispatch({
			type: 'STATE_EMPRESA',
			nodo_empresa: nodo_empresa,
			nombre_empresa: nombre_empresa
		});
	}

	render() {
		const { children } = this.props;

		return (
			<div className="principal">
				{this.renderContent()}
				{this.state.tipo !== null && this.renderRoutes()}
				<Alert stack={{ limit: 3 }} html={true} />
			</div>
		);
	}
}


export default withRouter(App);


// WEBPACK FOOTER //
// ./src/Components/App.js